var map = {
	"./Boomhut.svg": "b277",
	"./Hints_1.gif": "df13",
	"./Icoon_boek.png": "ce61",
	"./Kiko-Ani.gif": "21d4",
	"./KikoHints.gif": "c0dd",
	"./Klank-Kleur_WebV2.png": "a27f",
	"./Pop-up.png": "ba10",
	"./Tekstkader.png": "739e",
	"./achtergrond.png": "3fc3",
	"./afval-fase-1.png": "d279",
	"./afval-fase-2.png": "d574",
	"./afval-fase-3.png": "8489",
	"./avatar-1.png": "ed51",
	"./avatar-2.png": "e799",
	"./avatar-3.png": "388f",
	"./avatar-4.png": "18bf",
	"./avatar-5.png": "4e6b",
	"./avatar-6.png": "7b90",
	"./background-profiel.png": "33d3",
	"./background.jpg": "1100",
	"./badge_rugzak.png": "9780",
	"./badge_rugzak_small.png": "b161",
	"./bijl.png": "f8cc",
	"./bladeren_high.png": "a2ea",
	"./bladeren_low.png": "22eb",
	"./bladeren_medium.png": "4f3f",
	"./boekenplank.png": "a657",
	"./boom.png": "fdc7",
	"./boom1.png": "564a",
	"./boom3.png": "88d0",
	"./boomhut.jpg": "993b",
	"./boomstam.png": "b5bf",
	"./broom.png": "1b87",
	"./close-modal.png": "a68b",
	"./coinspopup-0.png": "35f2",
	"./coinspopup-1.png": "e8ff",
	"./coinspopup-2.png": "f660",
	"./coinspopup-3.png": "527d",
	"./coinspopup-4.png": "f2a5",
	"./compass-icon.png": "72c9",
	"./compass.png": "59ac",
	"./compass.svg": "01bc",
	"./first-world-bg.png": "2246",
	"./flipped-closed.png": "ecc9",
	"./flipped-open.png": "317d",
	"./fourth-world-bg.png": "09b8",
	"./girl.gif": "e763",
	"./go-back-arrow.png": "8b9b",
	"./icon-exercise.png": "f5ea",
	"./icoon-geluid.png": "732e",
	"./img/buttons/close-modal-alt.svg": "1a43",
	"./img/buttons/close-modal.png": "4c40",
	"./img/buttons/view-image.svg": "08ac",
	"./img/debug/bug.svg": "28cd",
	"./img/end-cave/bats.png": "d964",
	"./img/end-cave/diamond-1-no-shine.png": "fb6c",
	"./img/end-cave/diamond-1-slotted.png": "22b6",
	"./img/end-cave/diamond-1.png": "1c7f",
	"./img/end-cave/diamond-2-no-shine.png": "30c0",
	"./img/end-cave/diamond-2-slotted.png": "f17c",
	"./img/end-cave/diamond-2.png": "9318",
	"./img/end-cave/diamond-3-no-shine.png": "d629",
	"./img/end-cave/diamond-3-slotted.png": "e092",
	"./img/end-cave/diamond-3.png": "c05c",
	"./img/end-cave/diamond-4-no-shine.png": "ab71",
	"./img/end-cave/diamond-4-slotted.png": "65e4",
	"./img/end-cave/diamond-4.png": "f124",
	"./img/end-cave/diamond-shine.png": "e51a",
	"./img/end-cave/diamond-slot.png": "57e6",
	"./img/end-cave/end-cave.png": "abc3",
	"./img/end-cave/end_cave_world_cave.png": "2c81",
	"./img/end-cave/spider.png": "957c",
	"./img/end-cave/string.png": "b73a",
	"./img/end-cave/web.png": "95b6",
	"./img/exercises/difficulty-1-stars.png": "1581",
	"./img/exercises/difficulty-1.png": "e149",
	"./img/exercises/difficulty-2-stars.png": "fb78",
	"./img/exercises/difficulty-2.png": "4e4d",
	"./img/exercises/difficulty-3-stars.png": "b8f7",
	"./img/exercises/difficulty-3.png": "734e",
	"./img/exercises/exercise-passed-1.png": "77ec",
	"./img/exercises/exercise-passed-2.png": "2528",
	"./img/exercises/exercise-passed-3.png": "5dff",
	"./img/exercises/exercise_closed-1.png": "6349",
	"./img/exercises/exercise_closed.png": "9c4e",
	"./img/exercises/exercise_done_small.png": "6c96",
	"./img/exercises/exercise_open.png": "3f0a",
	"./img/exercises/exercise_passed.png": "73c4",
	"./img/exercises/exercise_paused.png": "f86f",
	"./img/exercises/exercise_paused_small.png": "6164",
	"./img/exercises/exercise_repeat_small.svg": "e7cb",
	"./img/exercises/exercise_test-1.gif": "f399",
	"./img/exercises/exercise_test-1.png": "1ca5",
	"./img/exercises/exercise_test-2.png": "59a2",
	"./img/exercises/exercise_test-3.png": "eef7",
	"./img/exercises/exercise_test-4.png": "6453",
	"./img/exercises/exercise_test-5.png": "0b63",
	"./img/exercises/exercise_test-6.png": "c708",
	"./img/exercises/exercise_test.png": "3379",
	"./img/exercises/repetition-border.png": "14c9",
	"./img/exercises/verdubbelaar_dark.png": "b14e",
	"./img/help-overlay/close.png": "9545",
	"./img/help-overlay/question-mark.png": "971f",
	"./img/lesson-page/title.png": "0388",
	"./img/profile/welcome-gate.png": "46b4",
	"./img/stars-1.png": "e5f7",
	"./img/stars-2.png": "3f06",
	"./img/stars-3.png": "cf19",
	"./img/topmenu/buddy-1.png": "6c5e",
	"./img/topmenu/buddy-2.png": "f518",
	"./img/topmenu/buddy-3.png": "93e4",
	"./img/topmenu/buddy-4.png": "ef1d",
	"./img/topmenu/buddy-5.png": "29f3",
	"./img/topmenu/buddy-6.png": "2b82",
	"./img/topmenu/fullscreen.png": "5c4d",
	"./img/topmenu/klankenkaart.png": "3124",
	"./img/topmenu/klankenkoort-icon.png": "080e",
	"./img/topmenu/logout.png": "4ad6",
	"./img/topmenu/map.png": "a768",
	"./img/topmenu/question-mark.png": "c39f",
	"./img/topmenu/treehouse.png": "dd09",
	"./img/topmenu/trophy.png": "4c31",
	"./img/world/diamond-background.png": "cdc0",
	"./img/world/step-anchor-without-anchor.png": "f0c7",
	"./img/world/step-anchor.png": "4e8b",
	"./img/world/video-wip.gif": "93f2",
	"./info-icon.png": "f49b",
	"./isoleren-btn.png": "0562",
	"./jumping-girl.png": "0e96",
	"./jungle-board.png": "184f",
	"./kiki-flying2.gif": "b7f9",
	"./kiko-body.png": "fad0",
	"./kiko-flying.gif": "e551",
	"./kiko-hint.png": "9a64",
	"./kiko-leftwing.png": "b037",
	"./kiko-rightwing.png": "3fdf",
	"./kiko.png": "5a96",
	"./klankenkaart.png": "da60",
	"./leaf-word-2.png": "232a",
	"./leaf-word.png": "ff78",
	"./lesitem.png": "1b78",
	"./lespagina-small-wit.png": "c7b9",
	"./lespagina_groot_wit.png": "3b83",
	"./lock.png": "5612",
	"./logboek-leaf.png": "138d",
	"./logboek-liaan-verticaal.png": "4b0d",
	"./logboek.png": "ba18",
	"./logo_1.png": "93d3",
	"./logo_groot.png": "d427",
	"./logo_groot33.png": "6de8",
	"./logo_klein.png": "f38f",
	"./menu-boomhut.png": "9af2",
	"./menu-enlarge.png": "ab62",
	"./menu-home.png": "7b65",
	"./menu-klankenkaart.png": "a9a7",
	"./menu-logout.png": "0ef9",
	"./menu-profiel.png": "1e26",
	"./modal-frame.png": "e79c",
	"./naslag.png": "3f5d",
	"./oefenen-btn.png": "bd08",
	"./opdracht-dictee.png": "82a4",
	"./opdracht-gehaald.png": "28f7",
	"./opdracht-niet-gehaald.png": "7387",
	"./opdracht-open.png": "6bbb",
	"./opdracht-pauze.png": "aced",
	"./opdracht_bg.png": "81e3",
	"./pdf/klankenkaart.pdf": "21e7",
	"./progress.png": "11e0",
	"./repetition-icon.png": "e2d4",
	"./sample.pdf": "963c",
	"./scss/animations.scss": "e32c",
	"./scss/exercises.scss": "b16b",
	"./scss/inputs.scss": "3fc9",
	"./scss/jungle.scss": "15d0",
	"./scss/main.scss": "c1c3",
	"./scss/page.scss": "ae68",
	"./scss/transitions/cardinal_slide.scss": "f3dc",
	"./scss/transitions/transitions.scss": "f05e",
	"./scss/variables.scss": "2295",
	"./scss/world.scss": "be78",
	"./second-world-bg.png": "e088",
	"./sound.mp3": "86e2",
	"./sound/ambience/jungle-background.mp3": "9bba",
	"./sound/ambience/world-4-background.mp3": "4780",
	"./sound/fx/coins.mp3": "fbfd",
	"./sound/fx/complete_exercise.mp3": "95e7",
	"./sound/fx/door-open.mp3": "0b71",
	"./sound/fx/unlock-reward.mp3": "d679",
	"./speaker_helezinnen.png": "b7e6",
	"./speaker_klanken.png": "a366",
	"./speaker_letters.png": "d237",
	"./speaker_woorden.png": "d3f9",
	"./speakericon.png": "fe0c",
	"./test-bg.png": "df20",
	"./third-world-bg.png": "083c",
	"./titelbalk-groen.png": "6f27",
	"./titelbalk.png": "db4f",
	"./treehouse-badge.png": "208b",
	"./treehouse-stats.png": "12a5",
	"./verdubbelaar.png": "de71",
	"./xp.png": "8873",
	"./zaag-.png": "a27f5",
	"./zaag.png": "023c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";